/**
 * Environment variables
 */
export const Env = {
  MODE: process.env.NODE_ENV || "development",
  APP_NAME: process.env.REACT_APP_NAME,
  BASE_URL: process.env.REACT_APP_BASE_URL || "",
  PORTAL_URL: process.env.REACT_APP_PORTAL_URL || "",
  CONTENT_HUB_URL: process.env.REACT_APP_CONTENT_HUB_URL || "",
  API_KEY: process.env.REACT_APP_API_KEY || "",
  API_SECRET: process.env.REACT_APP_API_SECRET || "",
};
